<template>
  <article>
    <img :src="bg" alt="bg" class="bg" />
    <img :src="homeLogo" alt="logo" class="homeLogo" />
    <h1 class="welcome">Welkom bij E' Health & Beauty</h1>

    <div class="contactCta">
      <a name="contact" @click="routeTo('/Contact')"> Maak een afspraak! </a>
    </div>
    <a name="scrollDown" href="#hello"> <i class="arrow"></i> </a>

    <div class="leftTextArea" id="hello">
      <div class="textHolder">
        <h2>Hallo</h2>
        <p>
          Mijn naam is Els Moorthamer, schoonheidsspecialiste en coach en altijd
          gefascineerd geweest naar het welzijn van de mens!
        </p>
        <p>
          Met als doel ons “goed voelen vanbinnen en vanbuiten”, ben ik gestart
          met het oprichten van mijn eigen praktijk!
        </p>
        <p>
          Ik geloof erin dat ons stralende zijn een duwtje in de rug kan
          gebruiken, en dat duwtje wil ik jullie maar al te graag geven!
        </p>
      </div>
      <img :src="tea" alt="tea" class="picHolder" />
    </div>

    <div class="lastPic rightTextArea">
      <div class="textHolder">
        <p>
          Schoonheid begint met goed zorg dragen voor ons fysieke lichaam, zowel
          innerlijk als uiterlijk!
        </p>
        <p>
          Mijn oorspronkelijke opleiding als schoonheidsspecialiste heb ik
          uitgebreid met opleidingen mental coach, mindfulness coach, stress
          coach en voedingscoach. Dit om jullie op verschillende niveaus te
          kunnen helpen en begeleiden.
        </p>
      </div>
      <img :src="body" alt="body" class="picHolder" />
    </div>
  </article>
</template>

<script>
import bg from '../assets/bg.webp';
import tea from '../assets/tea.webp';
import body from '../assets/free.webp';
import homeLogo from '../assets/logoWhite.webp';

export default {
  name: 'Home',
  components: {  },
   data() {
      return {
        bg: bg,
        tea: tea,
        body: body,
        homeLogo: homeLogo,
      }
    },
  methods: {
    routeTo(path) {
      this.$router.push(path).catch(() => {});
      if (this.showNav === true) this.showNav = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 94vh;
  object-fit: cover;
  display: block;
}

.welcome {
  position: absolute;
  text-align: center;
  top: 40%;
  height: 10vh;
  width: 100%;
}

.homeLogo {
  position: absolute;
  top: 15%;
  left: 43.5%;
  width: 13%;
}

.contactCta {
  position: absolute;
  text-align: center;
  top: 70%;
  width: 100%;

  a {
    font-size: 1.5em;
    height: 3vh;
    padding: 0.5em;
    cursor: pointer;
    border: 0.08em solid var(--caramel);
    border-radius: 0.5em;
    background-color: rgba(255, 255, 255, 0.4);

    &:hover {
      background-color: rgba(175, 141, 114, 0.5);
      transition: background-color 0.2s;
    }
  }
}

.arrow {
  position: absolute;
  top: 90vh;
  left: calc(50% - 0.6em);
  border: solid var(--caramel);
  z-index: 2;
  border-width: 0 0.2em 0.2em 0;
  display: inline-block;
  padding: 0.5em;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -webkit-animation: arrow 2s infinite; /* Safari 4+ */
  -moz-animation: arrow 2s infinite; /* Fx 5+ */
  -o-animation: arrow 2s infinite; /* Opera 12+ */
  animation: arrow 2s infinite; /* IE 10+, Fx 29+ */
}

.logo {
  position: absolute;
  width: 10%;
  margin-left: 45%;
  opacity: 0.5;
}

@media only screen and (max-width: 1100px) {
  h1 {
    font-size: 4em;
  }

  .contactCta {
    a {
      font-size: 1.4em;
    }
  }
}

@media only screen and (max-width: 950px) {
  h1 {
    font-size: 3em;
  }

  .homeLogo {
    top: 15%;
    left: 40%;
    width: 20%;
  }

  .contactCta {
    a {
      font-size: 1.2em;
    }
  }
}

@media only screen and (max-width: 850px) {
  .bg {
    height: 100vh;
  }
}

@media only screen and (max-width: 700px) {
  h1 {
    font-size: 2.5em;
  }

  .contactCta {
    a {
      font-size: 1.1em;
    }
  }
}

@keyframes arrow {
  0% {
    top: 90vh;
  }
  40% {
    top: 88vh;
  }
  80% {
    top: 90vh;
  }
  100% {
    top: 90vh;
  }
}
</style>
